<template lang="pug">
  div.municipalities
    div.table-choose-panel
      div.toolbar.toolbar_margin-bottom.toolbar_no-padding
        div.toolbar__line
          .semibold Муниципальные образования для перевозки
          form(@submit.prevent.stop="startSearch()").search
            input.search__input(
              type="search"
              v-model="searchQ"
              placeholder=""
            )
          .actions-panel
            e-button-edit(
              @click.stop.prevent="showModal = true"
            )
    div
      e-table-inner(
        :visibleColumns="visibleColumns"
        :itemsEndpoint="endpointListForInnerTable"
        ref="innerTable"
        :showDeleteButton="false"
        :afterFetchData="afterFetchData"
      )
    e-modal(
      v-if="showModal"
      @close="showModal = false"
      @confirm="saveList()"
      title="Выбор муниципальных образований"
    )
      slot
        e-table-checked-list(
          @checkedChange="listUpdate"
          :endpoint="endpointList"
          :earlyCheckedItems="earlyChecked"
          :showPaginate="true"
          defaultColWidth="100%"
          :actionColumnWidth="130"
        )
</template>

<script>
import { tko, atu } from '@/api/api-endpoints'

export default {
  name: 'transportation-with-zones',
  props: {
    fields: Object,
    apo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchQ: '',
      operationType: null,
      showModal: false,
      checkedLen: 0,
      checked: [],
      objects: [],
    }
  },
  computed: {
    visibleColumns() {
      return {
        geo_parent_name: { label: 'Муниципальное образование' },
        population: { label: 'Численность населения, чел.' },
      }
    },
    earlyChecked() {
      return { default: this.fields.mos }
    },
  },
  methods: {
    startSearch() {
      this.$refs.innerTable.updateTable()
    },
    updateDataInInnerTable() {
      this.$refs.innerTable.updateTable()
    },
    endpointListForInnerTable(ctx, query = { 'per-page': 10 }) {
      let route = { query }
      if (ctx.q) {
        route.query.q = ctx.q
      }
      if (ctx.paginateObj) {
        route.query = Object.assign(route.query, ctx.paginateObj)
      }
      if (ctx.currentSort) {
        route.query.sort = ctx.currentSort
      }

      route.query.id = this.fields.id

      if (this.searchQ) {
        route.query.q = this.searchQ
      } else {
        delete route.query.q
      }

      return route.query.id
        ? {
            url: tko.operatorTransportationZone(route.query.id),
            fields: {
              name: {
                label: 'Муниципальные образования для перевозки',
              },
            },
          }
        : { url: null }
    },
    afterFetchData(ctx, data) {
      data.data.forEach((item) => {
        this.objects.forEach((object) => {
          if (object.name === item.geo_parent_name) {
            this.fields.mos.push(object.id)
          }
        })
      })
      return data
    },
    async getObjects() {
      this.objects = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.apoObjects(this.$route),
        })
      ).data.data
    },
    async saveList() {
      await this.$store.dispatch('updateModel', {
        url: tko.operatorTransportationZoneUpdate(this.$route.params.id),
        data: { geo_object_ids: this.checked.default },
      })

      const items = []
      this.checked.default.forEach((item) => {
        this.objects.forEach((object) => {
          if (object.id === item) {
            items.push({ ...object, geo_parent_name: object.name })
          }
        })
      })
      let fields = Object.assign(this.fields, {
        mos: JSON.parse(JSON.stringify(this.checked.default)),
      })
      this.$set(this.fields, fields)

      this.$refs.innerTable.items.data = items
      this.showModal = false
    },
    listUpdate($event) {
      let { checked, checkedLen } = $event
      this.checkedLen = checkedLen
      this.checked = checked
    },
    endpointList(ctx, query = { 'per-page': 150 }) {
      let route = { query }
      if (ctx.q) {
        route.query.q = ctx.q
      }
      if (ctx.paginateObj) {
        route.query = Object.assign(route.query, ctx.paginateObj)
      }
      if (ctx.currentSort) {
        route.query.sort = ctx.currentSorttemplate('footer')
      }

      route.query.null_apo = this.apo
      return {
        url: atu.apoObjects(route),
        fields: {
          name: {
            label: 'Наименование',
          },
          parent_name: {
            label: 'Муниципальное образование',
          },
        },
      }
    },
  },
  created() {
    this.getObjects()
  },
}
</script>
